/**
 * Shared CSV / Excel(TSV) export helpers for HR Analytics.
 * Used by ExportButton (per-tile) and the report canvas "export all".
 */

export function downloadFile(content: string, filename: string, mimeType: string) {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function toCSV(data: Record<string, any>[]): string {
  if (data.length === 0) return "";
  const headers = Object.keys(data[0]);
  const rows = data.map((row) => headers.map((h) => JSON.stringify(row[h] ?? "")).join(","));
  return [headers.join(","), ...rows].join("\n");
}

export function toTSV(data: Record<string, any>[]): string {
  if (data.length === 0) return "";
  const headers = Object.keys(data[0]);
  const rows = data.map((row) => headers.map((h) => String(row[h] ?? "").replace(/\t/g, " ")).join("\t"));
  return [headers.join("\t"), ...rows].join("\n");
}

export interface TileExport {
  title: string;
  rows: Record<string, any>[];
}

/** Concatenate several tiles' rows into one document with a section header per tile. */
export function exportAllTiles(tiles: TileExport[], format: "csv" | "tsv"): string {
  const sep = format === "csv" ? "," : "\t";
  const blocks: string[] = [];
  for (const tile of tiles) {
    const body = format === "csv" ? toCSV(tile.rows) : toTSV(tile.rows);
    const titleLine = `${tile.title.replace(new RegExp(sep, "g"), " ")}`;
    blocks.push(`${titleLine}\n${body || "(no data)"}`);
  }
  return blocks.join("\n\n");
}
